"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyPlusDrawArrows = exports.dragNodeRedrawGradient = exports.linkStroke = exports.menu_conf_link_apparence_gradient = void 0;
const react_1 = __importDefault(require("react"));
const d3 = __importStar(require("d3"));
const react_bootstrap_1 = require("react-bootstrap");
const OpensankeyDrawFunction = __importStar(require("open-sankey/dist/SankeyDrawFunction"));
const OpensankeyUtils = __importStar(require("open-sankey/dist/SankeyUtils"));
const menu_conf_link_apparence_gradient = (t, multi_selected_links, data, set_data, is_activated, menu_for_style, selected_style_link) => {
    const parameter_to_modify = (menu_for_style) ? data.style_link : data.links;
    const selected_parameter = (menu_for_style) ? [data.style_link[selected_style_link]] : multi_selected_links.current;
    // const gradChecked = () => {
    //   let gradChecked = true
    //   multi_selected_links.current.map(d => {
    //     const l_grad=OpensankeyUtils.return_value_link(data,d,'gradient')
    //     gradChecked = (l_grad) ? gradChecked : false
    //   })
    //   return gradChecked
    // }
    const gradChecked = OpensankeyUtils.is_all_link_attr_same_value(data, selected_parameter, 'gradient', menu_for_style);
    return react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'gradiantDisabled', placement: 'top', delay: 500, overlay: (!is_activated) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'gradiantDisabled' },
            t('Menu.sankeyPlusDisabled'),
            " ")) : react_1.default.createElement(react_1.default.Fragment, null) },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (!is_activated) ? 'grey' : '#555555' } },
                    t('Flux.apparence.grad') + (OpensankeyUtils.is_link_diplaying_value_local(multi_selected_links, 'gradient', menu_for_style) ? '*' : ''),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, disabled: !is_activated, type: "checkbox", checked: gradChecked, onChange: evt => {
                        // selected_link.gradient = evt.target.checked
                        Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                            // d.gradient = evt.target.checked
                            OpensankeyUtils.assign_link_value_to_correct_var(d, 'gradient', evt.target.checked, menu_for_style);
                        });
                        set_data(Object.assign({}, data));
                    } }))));
};
exports.menu_conf_link_apparence_gradient = menu_conf_link_apparence_gradient;
const linkStroke = (l, data, getLinkValue) => {
    const defGradient = d3.select(' .opensankey #svg #sankey_def');
    const nodes = data.nodes;
    const n_source = nodes[l.idSource];
    const n_source_color = OpensankeyUtils.return_value_node(data, n_source, 'color');
    const n_target = nodes[l.idTarget];
    const n_target_color = OpensankeyUtils.return_value_node(data, n_target, 'color');
    const l_ori = OpensankeyUtils.return_value_link(data, l, 'orientation');
    const l_grad = OpensankeyUtils.return_value_link(data, l, 'gradient');
    const width_src = +d3.select(' .opensankey #' + l.idSource).attr('width');
    const height_src = +d3.select(' .opensankey #' + l.idSource).attr('height');
    const width_trgt = +d3.select(' .opensankey #' + l.idTarget).attr('width');
    // const height_trgt = +d3.select(' .opensankey #' + l.idTarget).attr('height')
    const gradient = defGradient.append('defs')
        .append('linearGradient')
        .attr('id', 'gradient-' + l.idSource + '-' + l.idTarget)
        .attr('gradientUnits', 'userSpaceOnUse');
    gradient.append('stop')
        .attr('id', 'stop-start')
        .attr('offset', '0%')
        .attr('stop-color', () => {
        if (nodes[l.idSource].x <= nodes[l.idTarget].x) {
            const n = n_source;
            if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                const selected_tag = n.tags[n.colorTag][0];
                const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                if (tag) {
                    return tag.color;
                }
            }
            return n_source_color;
        }
        else {
            const n = n_target;
            if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                const selected_tag = n.tags[n.colorTag][0];
                const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                if (tag) {
                    return tag.color;
                }
            }
            return n_target_color;
        }
    })
        .attr('stop-opacity', 1);
    gradient.append('stop')
        .attr('id', 'stop-end')
        .attr('offset', '100%')
        .attr('stop-color', () => {
        if (nodes[l.idSource].x <= nodes[l.idTarget].x) {
            const n = n_target;
            if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                const selected_tag = n.tags[n.colorTag][0];
                const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                if (tag) {
                    return tag.color;
                }
            }
            return n_target_color;
        }
        else {
            const n = n_source;
            if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                const selected_tag = n.tags[n.colorTag][0];
                const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                if (tag) {
                    return tag.color;
                }
            }
            return n_source_color;
        }
    })
        .attr('stop-opacity', 1);
    if (l_ori === 'hh' || l_ori === 'hv') {
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[l.idSource].x < nodes[l.idTarget].x) {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', nodes[l.idSource].x + width_src)
                    .attr('y1', '0')
                    .attr('x2', nodes[l.idTarget].x)
                    .attr('y2', 0);
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', nodes[l.idTarget].x + width_trgt)
                    .attr('y1', '0')
                    .attr('x2', nodes[l.idSource].x)
                    .attr('y2', 0);
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[l.idSource].x > nodes[l.idTarget].x) {
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
    }
    else if (l_ori === 'vv' || l_ori === 'hv') {
        //orientation vert-vert
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[l.idSource].y < nodes[l.idTarget].y) {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', 0)
                    .attr('y1', nodes[l.idSource].y + height_src)
                    .attr('x2', 0)
                    .attr('y2', nodes[l.idTarget].y);
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', 0)
                    .attr('y1', nodes[l.idTarget].y + height_src)
                    .attr('x2', 0)
                    .attr('y2', nodes[l.idSource].y);
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[l.idSource].y > nodes[l.idTarget].y) {
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
    }
    else if (l_ori === 'vh') {
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[l.idSource].x < nodes[l.idTarget].x) {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', nodes[l.idSource].x + width_src - 10)
                    .attr('y1', '0')
                    .attr('x2', nodes[l.idTarget].x)
                    .attr('y2', 0);
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode)
                    .attr('x1', nodes[l.idTarget].x + width_trgt + 10)
                    .attr('y1', '0')
                    .attr('x2', nodes[l.idSource].x)
                    .attr('y2', 0);
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[l.idSource].idNode + '-' + nodes[l.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[l.idSource].x > nodes[l.idTarget].x) {
                const n = n_source;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                const n = n_target;
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
    }
    return (l_grad && l.colorParameter === 'local') ? 'url(#gradient-' + l.idSource + '-' + l.idTarget + ')' : OpensankeyDrawFunction.linkStroke(l, data, getLinkValue);
};
exports.linkStroke = linkStroke;
// Function used to create gradient for each link, but are used only if the link has the gradient varibale at true
const dragNodeRedrawGradient = (nodes, link, data) => {
    const width_src = +d3.select(' .opensankey #' + link.idSource).attr('width');
    const height_src = +d3.select(' .opensankey #' + link.idSource).attr('height');
    const width_trgt = +d3.select(' .opensankey #' + link.idTarget).attr('width');
    //const height_trgt = +d3.select(' .opensankey #' + link.idTarget).attr('height')
    const n_source = nodes[link.idSource];
    const n_source_color = OpensankeyUtils.return_value_node(data, n_source, 'color');
    const n_target = nodes[link.idTarget];
    const n_target_color = OpensankeyUtils.return_value_node(data, n_target, 'color');
    const l_ori = OpensankeyUtils.return_value_link(data, link, 'orientation');
    if (l_ori === 'hh' || l_ori === 'hv') {
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[link.idSource].x < nodes[link.idTarget].x) {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', data.nodes[link.idSource].x + width_src)
                    .attr('y1', '0')
                    .attr('x2', nodes[link.idTarget].x)
                    .attr('y2', 0);
                const n = nodes[link.idSource];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', data.nodes[link.idTarget].x + width_trgt)
                    .attr('y1', '0')
                    .attr('x2', nodes[link.idSource].x)
                    .attr('y2', 0);
                const n = nodes[link.idTarget];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[link.idSource].x > nodes[link.idTarget].x) {
                const n = nodes[link.idSource];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                const n = nodes[link.idTarget];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
    }
    else if (l_ori === 'vv' || l_ori === 'hv') {
        //orientation vert-vert
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[link.idSource].y < nodes[link.idTarget].y) {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', 0)
                    .attr('y1', data.nodes[link.idSource].y + height_src)
                    .attr('x2', 0)
                    .attr('y2', data.nodes[link.idTarget].y);
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', 0)
                    .attr('y1', data.nodes[link.idTarget].y + height_src)
                    .attr('x2', 0)
                    .attr('y2', data.nodes[link.idSource].y);
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[link.idSource].y > nodes[link.idTarget].y) {
                return n_source_color;
            }
            else {
                return n_target_color;
            }
        });
    }
    else if (l_ori === 'vh') {
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-start').attr('stop-color', () => {
            if (nodes[link.idSource].x < nodes[link.idTarget].x) {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', data.nodes[link.idSource].x + width_src - 10)
                    .attr('y1', '0')
                    .attr('x2', nodes[link.idTarget].x)
                    .attr('y2', 0);
                const n = nodes[link.idSource];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode)
                    .attr('x1', data.nodes[link.idTarget].x + width_trgt + 10)
                    .attr('y1', '0')
                    .attr('x2', nodes[link.idSource].x)
                    .attr('y2', 0);
                const n = nodes[link.idTarget];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
        d3.select(' .opensankey #gradient-' + nodes[link.idSource].idNode + '-' + nodes[link.idTarget].idNode + ' #stop-end').attr('stop-color', () => {
            if (nodes[link.idSource].x > nodes[link.idTarget].x) {
                const n = nodes[link.idSource];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_source_color;
            }
            else {
                const n = nodes[link.idTarget];
                if (n.colorTag in n.tags && n.colorParameter === 'groupTag') {
                    const selected_tag = n.tags[n.colorTag][0];
                    const tag = data.nodeTags[n.colorTag].tags[selected_tag];
                    if (tag) {
                        return tag.color;
                    }
                }
                return n_target_color;
            }
        });
    }
};
exports.dragNodeRedrawGradient = dragNodeRedrawGradient;
const SankeyPlusDrawArrows = (n, selected_tags, data, scale, inv_scale, getLinkValue, display_style) => {
    OpensankeyDrawFunction.drawArrows(n, selected_tags, data, scale, inv_scale, getLinkValue, display_style);
    for (let i = 0; i < n.inputLinksId.length; i++) {
        const l_arrow = OpensankeyUtils.return_value_link(data, data.links[n.inputLinksId[i]], 'arrow');
        const l_grad = OpensankeyUtils.return_value_link(data, data.links[n.inputLinksId[i]], 'gradient');
        if (l_arrow && l_grad) {
            d3.selectAll(' .opensankey #' + n.inputLinksId[i] + '_arrow').attr('fill', OpensankeyUtils.node_color(n, data));
        }
    }
};
exports.SankeyPlusDrawArrows = SankeyPlusDrawArrows;
